// Formatear dinero
export const formatMoney = (value) => {
  return `S/ ${parseFloat(value || 0).toLocaleString('es-PE', { minimumFractionDigits: 2 })}`;
};

// Obtener fecha local en formato YYYY-MM-DD (para inputs de fecha)
export const getLocalDate = (date = new Date()) => {
  const d = date instanceof Date ? date : new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

// Formatear fecha
export const formatDate = (date) => {
  if (!date) return '-';
  // Agregar T12:00:00 para evitar problemas de zona horaria
  const dateStr = typeof date === 'string' && date.length === 10 ? date + 'T12:00:00' : date;
  return new Date(dateStr).toLocaleDateString('es-PE', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

// Formatear fecha y hora
export const formatDateTime = (date) => {
  if (!date) return '-';
  const dateStr = typeof date === 'string' && date.length === 10 ? date + 'T12:00:00' : date;
  return new Date(dateStr).toLocaleString('es-PE', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Obtener iniciales
export const getInitials = (name) => {
  if (!name) return '??';
  return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
};

// Colores por rol
export const roleColors = {
  ADMIN: 'from-violet-500 to-purple-600',
  PRESIDENTE: 'from-amber-500 to-orange-600',
  TESORERO: 'from-emerald-500 to-teal-600',
  SECRETARIO: 'from-blue-500 to-indigo-600',
  PROPIETARIO: 'from-slate-500 to-slate-600',
  PORTERO: 'from-cyan-500 to-blue-600'
};

// Colores por estado
export const statusColors = {
  ACTIVO: 'success',
  ACTIVA: 'success',
  OPERATIVO: 'success',
  CONFIRMADA: 'success',
  APROBADO: 'success',
  APROBADA: 'success',
  COMPLETADO: 'success',
  RESUELTO: 'success',
  ENTREGADO: 'success',
  PENDIENTE: 'warning',
  EN_PROCESO: 'info',
  EN_REPARACION: 'warning',
  BORRADOR: 'default',
  MOROSO: 'danger',
  INACTIVO: 'danger',
  CANCELADA: 'danger',
  RECHAZADA: 'danger',
  RECHAZADO: 'danger',
  FUERA_DE_SERVICIO: 'danger',
  DADO_DE_BAJA: 'danger',
  FINALIZADA: 'info',
  VENCIDO: 'danger',
  ARCHIVADO: 'default'
};